import { EvalStack, Record } from '@swim/recon';
import { View } from './view';
var ViewController = (function () {
    function ViewController() {
        this._view = null;
    }
    Object.defineProperty(ViewController.prototype, "view", {
        get: function () {
            return this._view;
        },
        set: function (newView) {
            var oldView = this._view;
            if (oldView !== newView) {
                this._view = newView;
                if (this._view) {
                    this.didSetView(this._view);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ViewController.prototype.didSetView = function (view) {
    };
    ViewController.prototype.didSetParentView = function (parentView, view) {
    };
    ViewController.prototype.didInsertChildView = function (childView, view) {
    };
    ViewController.prototype.didRemoveChildView = function (childView, view) {
    };
    ViewController.prototype.viewScope = function () {
        var scope = Record.empty();
        return scope;
    };
    ViewController.prototype.stack = function () {
        var stack = new EvalStack();
        stack.push(View.GlobalScope);
        stack.push(this.viewScope());
        return stack;
    };
    ViewController.prototype.didSetModel = function (model, view) {
    };
    ViewController.prototype.didSetStyle = function (newStyle, oldStyle, view) {
    };
    ViewController.prototype.didSetState = function (newState, oldState, view) {
    };
    ViewController.prototype.willResize = function (view) {
    };
    ViewController.prototype.didResize = function (view) {
    };
    ViewController.prototype.willReview = function (viewable, view) {
    };
    ViewController.prototype.didReview = function (viewable, view) {
    };
    ViewController.prototype.willRedraw = function (view) {
    };
    ViewController.prototype.didRedraw = function (view) {
    };
    return ViewController;
}());
export { ViewController };
//# sourceMappingURL=data:application/json;base64,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